import { css } from '@emotion/react'
import { HTMLMotionProps, motion } from 'motion/react'

export interface ListItemProps extends HTMLMotionProps<'div'> {}
export default function ListItem({ children, ...props }: ListItemProps) {
	return (
		<motion.div
			css={css`
				display: grid;
				gap: 12px;
				align-items: center;
				padding: 10px 0;
				background-color: var(--bg-body-1);
				box-shadow: 0 -0.5px 0 0 var(--tint-shadow-1);
				margin-top: 0.5px;
			`}
			{...props}
		>
			{children}
		</motion.div>
	)
}
